/*
 * @Description: 系统参数
 * @Author: wangwangwang
 * @Date: 2020-06-30 14:18:14
 * @LastEditors: wangwangwang
 * @LastEditTime: 2020-07-01 13:53:45
 */
import request from '@/utils/request'
export const Download = "/base/system/params/export";

// 获取系统参数
export function queryPage(params) {
  return request({
    url: '/base/system/params/query_page',
    method: 'post',
    data: params
  })
}
// 新增、编辑系统参数
export function saveOrUpdate(params) {
  return request({
    url: '/base/system/params/save_or_update',
    method: 'post',
    data: params
  })
}
// 修改系统参数状态
export function updateOrDelete(params) {
  return request({
    url: '/base/system/params/batch_update_or_delete',
    method: 'post',
    data: params,
  })
}
/**同步缓存*/
export function sync_cache() {
  return request({
    url: '/base/system/params/sync_cache',
    method: 'get',
  })
}

